import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UpdateAppDialog from './components/update-app-dialog';
import ModalBgCover from './components/modal-bg-cover';
import {gaSetUser} from '../../../src/globs/utils/google-analytics'

class App extends Component {
  static propTypes = {
    app: PropTypes.shape({
      isMounted: PropTypes.bool,
      isReady: PropTypes.bool,
      isOutdated: PropTypes.bool,
    }).isRequired,
    user: PropTypes.shape({}).isRequired,
    appMount: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
  }
  state = {
    showNotificationsPopD: false,
  }

  componentDidMount() {
    const { props } = this;
    gaSetUser(props.user);
    if (props.user.id) {
      props.appMount(props.user);
    }
  }

  reloadApp = () => {
    const { props } = this;
    props.appOutdated(false);
    props.appReload();
  }
  render() {
    const { props } = this;
    const appClasses = classNames('lr-app', {
      'is-visible': props.app.isMounted,
    });

    const showAppUpdateDialog = props.app.isOutdated;
    // console.log('isOutdated', showAppUpdateDialog);
    return (
      <div className={appClasses}>
        <div className="lr-main-view">
          {props.children}

          {(showAppUpdateDialog) &&
            <ModalBgCover />
          }
          { showAppUpdateDialog &&
            <UpdateAppDialog
              title="App updated"
              message="Sales Officer App has been updated. Refresh the app so you can use the new features."
              onDismiss={this.reloadApp}
              dismissLabel="Refresh"
            />
          }
        </div>
      </div>
    );
  }
}

export default App;
